//import { Token } from "typescript";
import { actionCreatorFactory } from "typescript-fsa";
import {TokenModel} from '../typing/generalLoginType';

const actionCreator = actionCreatorFactory("LoginMana");

//const setToken = actionCreator<{newtoken:string}>("SET_TOKEN");
//const invalidateToken = actionCreator<{}>("INVALIUDATE_TOKEN");

const doLogin = actionCreator<{Token:TokenModel}>("TryLogin");
const setUserAndPassword = actionCreator<{user:string, pw:string}>("SetUserAndPw");
const revokeLogin = actionCreator<{}>("FailedLogin");
const setValueChange = actionCreator<{data:string, parameter:string}>("ChangeValueOfLogin");
const resetPW = actionCreator<{user:string}>("ResetPasswordRequest");
/** The token the hub renewed after an own password change replaces the current one (anima_core#24). */
const renewToken = actionCreator<{token:string}>("RenewToken");

export const loginActions = {doLogin, revokeLogin,setUserAndPassword,setValueChange, resetPW, renewToken };